import { createStyles, makeStyles, Theme } from '@material-ui/core';
import React from 'react';

import { useIsAssemblyBrandEnabled } from 'src/hooks/useIsAssemblyBrandEnabled';
import { CopilotAdminAuthBackground } from 'src/theme/colors';

const useStyles = makeStyles<Theme, { isAssemblyBrandEnabled: boolean }>(
  (theme) =>
    createStyles({
      '@global': {
        '*': {
          margin: 0,
          padding: 0,
          boxSizing: 'inherit',
        },
        html: {
          height: '100%',
          width: '100%',
          boxSizing: 'border-box',
          '-webkit-font-smoothing': 'antialiased',
          '-moz-osx-font-smoothing': 'grayscale;',
        },
        body: {
          height: '100%',
          width: '100%',
          fontSize: '13px',
          lineHeight: 1.2,
          margin: 0,
          // only apply copilot bg color on desktop
          [theme.breakpoints.up('sm')]: {
            backgroundColor: ({ isAssemblyBrandEnabled }) =>
              isAssemblyBrandEnabled ? 'none' : CopilotAdminAuthBackground,
          },
        },
        '#app': {
          height: '100%',
          width: '100%',
        },
      },
    }),
);

export const OnboardingPageLayout: React.FC = ({ children }) => {
  const { isAssemblyBrandEnabled } = useIsAssemblyBrandEnabled();
  useStyles({ isAssemblyBrandEnabled });

  return (
    <div className="h-full flex flex-col">
      <div className="w-full m-auto">{children}</div>
    </div>
  );
};
